import {AfterViewChecked, Component, Inject, DOCUMENT} from '@angular/core';

import {CustomScrollingService} from '@app/services/custom-scrolling.service';
import {CmsComponentData} from '@spartacus/storefront';
import {CmsParagraphComponent} from '@spartacus/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {NgTemplateOutlet} from '@angular/common';

const SELECTOR: string = 'dcp-page-index-headline';

/**
 * The CmsPageIndexComponent can be integrated on any page.
 * It will get all Elements with a certain css class and build an index with links to the found Elements.
 */
@UntilDestroy()
@Component({
  selector: 'dcp-page-index',
  templateUrl: './dcp-page-index.component.html',
  styleUrls: ['./dcp-page-index.component.scss'],
  imports: [NgTemplateOutlet],
})
export class DcpPageIndexComponent implements AfterViewChecked {
  headlines: HTMLElement[] = [];

  constructor(
    @Inject(DOCUMENT) private document: any,
    private customScrollingService: CustomScrollingService,
    public componentData: CmsComponentData<CmsParagraphComponent>,
  ) {}

  ngAfterViewChecked() {
    this.componentData.data$.pipe(untilDestroyed(this)).subscribe(() => {
      this.collectHeadLineElements();
    });
  }

  collectHeadLineElements() {
    this.headlines = Array.from(this.document.getElementsByClassName(SELECTOR));
  }

  scrollIntoView(element: HTMLElement) {
    this.customScrollingService.scrollToElement(element);
  }

  hasClass(h: HTMLElement, className: string): boolean {
    return h.classList.contains(className);
  }
}
